import './style.scss'
import { GLOBAL_FREIGHT_RATES } from 'Utils/Constants'
import React from 'react'

function GlobalFreightRates() {
  return (
    <div className="global-freight-container">
      <img className="global-freight-image" src={GLOBAL_FREIGHT_RATES.image} alt="Global-Freight-Rates" />
    </div>
  )
}

export default GlobalFreightRates
